import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import ModalForUploadSignetExample from './ModalForUploadSignetExample';
import withTranslations from '../../utils/HighOrderComponent';
import { addNewButton } from '../../utils';
import SignetExampleRow from './SignetExampleRow';

class SignetExampleTable extends Component {
  handleUpload = (data) => {
    const { NotificationMessages } = this.props.t || {};
    this.props.uploadSignetExample(
      data,
      () => this.props.handlePreviewClose(),
      NotificationMessages
    );
  };

  render() {
    const { t, downloadExample, signetExampleList } = this.props || {},
      { HeaderColumns, Labels, Tooltips } = t || {};

    const signetExamples = signetExampleList?.map((signetExample, index) => (
      <SignetExampleRow
        index={index + 1}
        key={signetExample.id}
        signetExample={signetExample}
        downloadExample={downloadExample}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{Labels.titleTable}</Card.Title>
                </Col>
                <Col className="addUser col-md-1 ml-auto">
                  {addNewButton(
                    () => this.props.handleShowModal(),
                    Tooltips.addNew
                  )}
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr>
                  <th width="7%">#</th>
                  <th>{HeaderColumns.name}</th>
                  <th width="11%" className="text-center">
                    {HeaderColumns.preview}
                  </th>
                  <th width="13%" className="text-center">
                    {HeaderColumns.download}
                  </th>
                </tr>
              </thead>
              <tbody>{signetExamples}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.props.show && (
          <ModalForUploadSignetExample
            handleUpload={this.handleUpload}
            handleClose={this.props.handlePreviewClose}
            show={this.props.show}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(SignetExampleTable, 'SignetExampleTable');
